import React from 'react'
import ConfirmedTickets from './confirmed-tickets/confirmed-tickets.container'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'
import PointsConversionService from './../../../services/points-conversion.service'
import BusSeatSelectionSelectors from '../../../selectors/bus-seat-selection.selectors'
import { Creators as SiteCreators } from '../../../ducks/site/site'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import TripPriceHelper from '../../../helpers/trip-price.helper'
import {
	PAYMENT_METHODS,
	BUS_COMPANIES,
	purchaseOption,
} from '../../../constants'
import { SectionTitle } from './common'

class OrderSummaryConfirmationComponent extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			accumulatedPoints: 0,
		}
	}

	calculateSelectedBusSeatsValues(selectedBusSeats, tripPrice, isReturn) {
		let totalValue = 0
		let totalPoints = 0

		selectedBusSeats.forEach((busSeat) => {
			let objPrice = TripPriceHelper.calculateWithDiscount(
				tripPrice,
				busSeat.discount,
				busSeat.price
			)

			totalValue +=
				objPrice.tarifa +
				(isReturn ? objPrice.imposto + objPrice.pedagio : 0) -
				objPrice.valorDesconto

			totalPoints += objPrice.pontos
		})

		return {
			totalValue,
			totalPoints,
		}
	}

	async componentDidMount() {
		const {
			tripGoingSummary,
			tripPriceGoing,
			tripPriceReturn,
			selectedBusSeatsGoing,
			selectedBusSeatsReturn,
			showLoading,
			hideLoading,
			calculatedValues,
		} = this.props

		const { totalPoints: totalPointsGoing } =
			this.calculateSelectedBusSeatsValues(
				selectedBusSeatsGoing,
				tripPriceGoing,
				false
			)

		const { totalPoints: totalPointsReturn } =
			this.calculateSelectedBusSeatsValues(
				selectedBusSeatsReturn,
				tripPriceReturn,
				true
			)

		const totalPoints = totalPointsGoing + totalPointsReturn

		if (totalPoints > 0) return

		const moveflexPartner = tripGoingSummary.busCompany.toLowerCase()

		try {
			showLoading()

			const { data } = await PointsConversionService.convertToPoints(
				calculatedValues.totalBpeValue,
				moveflexPartner
			)

			if (data) {
				this.setState({ accumulatedPoints: data })
			}
		} catch (error) {
		} finally {
			hideLoading()
		}
	}

	render() {
		const {
			user,
			paymentMethod,
			hasReturnTrip,
			isConfirmationStep,
			tripGoingSummary,
			tripReturnSummary,
			serviceCharge,
		} = this.props

		const busCompanyGoing = tripGoingSummary.busCompany
		const busCompanyReturn = tripReturnSummary.busCompany

		const isCompanyEligibleForPoints =
			busCompanyGoing &&
			busCompanyGoing.toUpperCase() === BUS_COMPANIES.PLANALTO &&
			(!busCompanyReturn ||
				(busCompanyReturn &&
					busCompanyReturn.toUpperCase() === BUS_COMPANIES.PLANALTO))

		let pointsText = ''
		let showPointsMessage = false

		const isOnlyValues = serviceCharge.purchaseOption == purchaseOption.value

		if (isCompanyEligibleForPoints && isOnlyValues) {
			const accumulatedPoints =
				this.state.accumulatedPoints.toLocaleString('pt-BR')

			if (
				accumulatedPoints > 0 &&
				paymentMethod !== PAYMENT_METHODS.MUVICARD
			) {
				showPointsMessage = true
				pointsText =
					user !== null
						? `Você irá acumular ${accumulatedPoints} pontos Muviflex`
						: `Cadastre-se até a data da viagem e ganhe ${accumulatedPoints} Pontos`
			}
		}

		return (
			isConfirmationStep && (
				<div>
					<SectionTitle title="Ida" />
					<ConfirmedTickets />
					{hasReturnTrip && (
						<React.Fragment>
							<SectionTitle title="Volta" />
							<ConfirmedTickets isReturn />
						</React.Fragment>
					)}
					{showPointsMessage ? (
						<React.Fragment>
							<span className="blue f-x-large">{pointsText}</span>
							<div className="display-flex flex-direction-column">
								<span>
									&#9679; Os pontos têm o prazo de até 15 dias após a
									data de viagem para serem creditados.
								</span>
								<span>
									&#9679; Os pontos são creditados no cadastro do
									passageiro que realizou a viagem.
								</span>
							</div>
						</React.Fragment>
					) : null}
				</div>
			)
		)
	}
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
		},
		dispatch
	)

const mapStateToProps = (store) => ({
	user: store.user,
	origin: store.ticketSale.origin,
	destination: store.ticketSale.destination,
	orderNumber: store.ticketSale.orderNumber,
	muvicardLimit: store.ticketSale.muvicardLimit,
	paymentMethod: store.ticketSale.paymentMethod,
	discountLabel: store.ticketSale.discountLabel,
	discountValue: store.ticketSale.discountValue,
	discountPercent: store.ticketSale.discountPercent,
	hasReturnTrip: TicketSaleSelectors.hasReturnTrip(store),
	tripPriceGoing: TicketSaleSelectors.getTripPriceGoing(store),
	tripPriceReturn: TicketSaleSelectors.getTripPriceReturn(store),
	tripGoingSummary: TicketSaleSelectors.getTripGoingSummary(store),
	isConfirmationStep: TicketSaleSelectors.isConfirmationStep(store),
	serviceCharge: TicketSaleSelectors.getServiceChargeSelector(store),
	tripReturnSummary: TicketSaleSelectors.getTripReturnSummary(store),
	discountPercentage: store.ticketSale.discountCoupon.discountPercentage,
	selectedBusSeatsGoing: BusSeatSelectionSelectors.getSelectedBusSeatsGoing(
		store.busSeatSelection
	),
	selectedBusSeatsReturn: BusSeatSelectionSelectors.getSelectedBusSeatsReturn(
		store.busSeatSelection
	),
	calculatedValues: TicketSaleSelectors.getCalculatedValues(store),
})

const OrderSummaryConfirmation = connect(
	mapStateToProps,
	mapDispatchToProps
)(OrderSummaryConfirmationComponent)

export default OrderSummaryConfirmation
